import $ from 'jquery'
import { NumberToLetter } from 'convertir-nombre-lettre';
import FileUpload from '@/components/file-upload'
import store_assurance from '@/store/mods/parametres/assurance'
import store_operation from "@/store/mods/caisse/operations"
import store_compte from '@/store/mods/caisse/compte.js'
import { numerosBon, mentionsIdentite, grouperParRubrique, modesDevise } from '@/utils/facture-assurance'

// N° du bon de la société saisi à la Caisse, porté par la ligne de consultation du patient : il figure sur la
// facture déposée chez l'assureur (règle partagée avec l'impression, utils/facture-assurance).
export { numerosBon }

// Impression (05/10/2026) : par société, par patient, ou une facture par patient (individuelle) pour les noms cochés.
export const FORMATS_IMPRESSION = [
    { slug: 'by_societe', libelle: 'Par société' },
    { slug: 'by_patient', libelle: 'Par patient' },
    { slug: 'individuel', libelle: 'Individuelle : une facture par patient' }
]

export default {
    name: 'manage-action-creance-assurance',
    components: {
        FileUpload
    },
    props: {
        selected_facture: {
            type: Object,
            default: () => {}
        },
        action_toggler: {
            type: Number,
            default: 0
        },
        mode_suivi: {
            type: String,
            default: 'relance'
        },
        selected_facture_detail: {
            type: Array,
            default: () => []
        },
        detail_toggler: {
            type: Number,
            default: 0
        },
        historique_toggler: {
            type: Number,
            default: 0
        },
        payment_toggler: {
            type: Number,
            default: 0
        },
        current_date_filter: {
            type: Object,
            default: () => {}
        },
        is_month: {
            type: Boolean,
            default: false
        },
        is_assurance_bill: {
            type: Boolean,
            default: true
        },
        user_info: {
            type: Object,
            default: () => {}
        },
        is_facture: {
            type: Number,
            default: 0
        },
        type_facture: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            is_confirm: false,
            is_error: false,
            montant_en_lettre: '',
            date_action: new Date(Date.now() - new Date().getTimezoneOffset()*60000).toISOString().slice(0,16),
            file_upload: null,
            commentaire: '',
            personne_contactee: '',
            promesse_paiement: '',
            prochaine_relance: '',
            rendez_vous_at: '',
            mode_paiement: 'cheque',
            action_attendue: '',
            montant_paye: '',
            devise_paiement: 'CDF',
            mode_paiement_recu: '',
            payment_summary: null,
            payment_loading: false,
            payment_request_id: '',
            promesse_apres_acompte: false,
            promesse_montant: '',
            promesse_date: '',
            promesse_contact: '',
            promesse_action: '',

            view_patients: [],
            view_by_societe: [],

            fields: [
                { key: 'date', label: 'Date' },
                { key: 'patient', label: 'Patient' },
                { key: 'num_bon', label: 'Numéro du bon' },
                { key: 'sum_part_assureur', label: 'Total Part Assureur' }
            ],

            field_patients: [
                { key: 'date', label: 'Date' },
                { key: 'prestation', label: 'Prestation' },
                { key: 'pu', label: 'Prix unitaire' },
                { key: 'qte', label: 'Qte' },
                { key: 'part_assureur', label: 'Part Assureur' }
            ],

            fields_suivi_facture: [
                { key: 'evt', label: 'Évènement' },
                { key: 'auteur', label: 'Auteur' },
                { key: 'date', label: 'Date' },
                { key: 'commentaire', label: 'Détails' },
                { key: 'preuve', label: 'Preuve' }
            ],

            search_filter: "",
            perPage: -1,
            print_per_page: -1,
            currentPage: 1,
            type_view: 'by_societe',
            total_facture: 0,
            total_en_lettre: '',
            view_types: [
                { slug: 'by_societe', libelle: 'Par société' },
                { slug: 'by_patient', libelle: 'Par patient' }
            ],
            selected_view_type: { slug: 'by_societe', libelle: 'Par société' },
            is_suffixe: 0,
            msg_error: '',
            save_loading: false,
            info_societe: null,
            historique_facture: [],
            is_empty: false,
            is_loading: true,
            attach_file_viewer: false,
            can_preview: false,
            filename: '',

            banques: [],
            compte_destinations: [
                { id: 6, libelle: 'Compte de dépôt' },
                { id: -1, libelle: 'Banque' }
            ],
            selected_compte: null,
            selected_banque: null,
            can_show_banque: false,
            can_print: false,
            final_selected_compte: null,
            is_ecart: false,
            must_justify: false,
            ecart: 0,

            // Options d'impression, ouvertes au clic sur « Imprimer »
            options_impression: false,
            formats_impression: FORMATS_IMPRESSION,
            format_impression: 'by_societe',
            patients_coches: [],
            devise_impression: 'principale'
        }
    },

    watch: {
        action_toggler() {
            this.clearError()
            if (this.selected_facture.sum_part_assureur && this.selected_facture.sum_part_assureur > 0) {
                this.montant_en_lettre = NumberToLetter(this.selected_facture.sum_part_assureur)
            }

            this.info_societe = null
            this.date_action = this.maintenantClinique()
            this.personne_contactee = ''
            this.promesse_paiement = ''
            this.prochaine_relance = ''
            this.rendez_vous_at = ''
            this.mode_paiement = 'cheque'
            this.action_attendue = ''
            if (this.is_assurance_bill === false) {
                this.fetchSocietInfoByID()
            }
        },

        detail_toggler() {
            this.view_by_societe = []
            this.view_patients = []
            this.selected_view_type = { slug: 'by_societe', libelle: 'Par société' }
            this.options_impression = false
            this.devise_impression = 'principale'

            this.total_facture = this.selected_facture.sum_part_assureur
            this.total_en_lettre = NumberToLetter(this.total_facture)
            // this.setViewPatient()
            this.setViewPatientBySociete()
        },

        selected_view_type() {
            if (this.selected_view_type.slug == 'by_societe') {
                this.setViewPatientBySociete()
            } else {
                this.setViewPatient()
            }
        },

        historique_toggler() {
            this.attach_file_viewer = false
            this.fetchSuiviAssurance()
        },
        
        payment_toggler() {
            this.date_action = this.maintenantClinique()
            this.clearError()
            this.devise_paiement = 'CDF'
            this.mode_paiement_recu = ''
            this.payment_summary = null
            this.promesse_apres_acompte = false
            this.promesse_montant = ''
            this.promesse_date = ''
            this.promesse_contact = ''
            this.promesse_action = ''
            this.payment_request_id = (window.crypto && window.crypto.randomUUID)
                ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`
            this.fetchBanques()
            this.chargerPaiementsFacture()
            if (this.$refs.pay_form) this.$refs.pay_form.reset()
        },

        selected_compte() {
            this.msg_error = ''
            this.can_show_banque = false
            if (this.selected_compte && this.selected_compte.id == -1) {
                this.can_show_banque = true
            }

            this.final_selected_compte = this.selected_compte && this.selected_compte.id != -1 ? this.selected_compte : this.selected_banque
        },

        commentaire() {
            this.must_justify = false
        },

        devise_paiement() {
            this.montant_paye = ''
            this.is_confirm = false
        },

        montant_paye() {
            this.msg_error = ''
            this.is_confirm = false
            const confirmation = document.getElementById('cfrm-pay')
            if (confirmation) confirmation.checked = false
            if (this.payment_summary && this.montantCdfSaisi >= Number(this.payment_summary.montant_restant)) {
                this.promesse_apres_acompte = false
            }
        }
    },

    computed: {
        modes_devise() {
            return modesDevise(this.currency_info || {})
        },

        // Patients de la facture, dans l'ordre d'affichage, pour cocher ceux à sortir individuellement.
        patients_facture() {
            const vus = []
            ;(this.selected_facture_detail || []).forEach(ligne => { if (vus.indexOf(ligne.patient) === -1) vus.push(ligne.patient) })
            return vus
        },

        impression_impossible() {
            return this.format_impression === 'individuel' && this.patients_coches.length === 0
        },

        resteApresAcompte() {
            return Math.max(0, Number(this.payment_summary && this.payment_summary.montant_restant || 0) - this.montantCdfSaisi)
        },
        montantCdfSaisi() {
            const montant = Number(this.montant_paye || 0)
            const taux = Number(this.currency_info && this.currency_info.rate || 0)
            return this.devise_paiement === 'USD' ? Math.round(montant * taux) : montant
        }
    },

    mounted() {
        Array.prototype.groupBy = function (key) {
            return this
                .reduce((hash, obj) => {
                    if (obj[key] === undefined) return hash;
                    return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
                }, {})
        };
    },
    
    methods: {
        maintenantClinique() {
            const parts = this.getDatePartsInClinicTimezone(new Date())
            return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`
        },

        formatEcheanceRecouvrement(value) {
            const iso = String(value).replace(' ', 'T')
            const date = new Date(/[zZ]|[+-]\d\d:\d\d$/.test(iso) ? iso : iso + 'Z')
            const parts = this.getDatePartsInClinicTimezone(date)
            return parts ? `${parts.day}/${parts.month}/${parts.year} à ${parts.hour}h${parts.minute}` : ''
        },
        clearError() {
            this.file_upload = null
            this.commentaire = ''
            this.montant_paye = ''
            this.selected_compte = null
            this.selected_banque = null
            this.can_show_banque = false
            this.is_ecart = false
            this.must_justify = false

            this.is_confirm = false
            this.msg_error = ''
            let cfrm = document.getElementById('cfrm-arr') 
            if (cfrm && cfrm.checked) {
                cfrm.checked = false
            }
        },

        fetchBanques() {
            this.is_loading = true

            store_compte.getCompteBanque().then((response) => {
                this.banques = response.data
                this.is_loading = false
            })
        },

        fetchSuiviAssurance() {
            this.is_error = false
            this.is_loading = true
            const data = {
                facture_id: this.selected_facture.facture_id
            }
            store_operation.getSuiviFactureAssurance(data).then((response) => {
                this.historique_facture = response
                if (this.historique_facture.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                }
                this.is_loading = false
            }).catch(() => {
                this.is_loading = false
                this.is_error = true
            })
        },

        async chargerPaiementsFacture() {
            this.payment_loading = true
            try {
                const response = await store_operation.getPaiementsFacture(this.selected_facture.facture_id)
                this.payment_summary = response.data
                this.msg_error = ''
            } catch (error) {
                this.msg_error = (error.response && error.response.data && error.response.data.message) || 'Impossible de charger le solde et les versements de la facture.'
            } finally {
                this.payment_loading = false
            }
        },

        async enregistrerAcompte() {
            if (this.save_loading || this.payment_loading || !this.payment_summary) return
            this.msg_error = ''
            const valid = await this.$refs.pay_form.validate()
            if (!valid) {
                this.msg_error = 'Renseignez la date, le montant et le compte destination.'
                return
            }
            const montantSaisi = Number(this.montant_paye)
            const amount = this.montantCdfSaisi
            const taux = Number(this.currency_info && this.currency_info.rate || 0)
            const destination = this.selected_compte && this.selected_compte.id == -1 ? this.selected_banque : this.selected_compte
            if (!Number.isFinite(montantSaisi) || montantSaisi <= 0 || Math.abs(Math.round(montantSaisi * 100) - montantSaisi * 100) > 1e-6 ||
                (this.devise_paiement === 'CDF' && !Number.isSafeInteger(montantSaisi)) ||
                (this.devise_paiement === 'USD' && !(taux > 0)) ||
                !Number.isSafeInteger(amount) || amount <= 0 || amount > this.payment_summary.montant_restant) {
                this.msg_error = 'Le montant reçu doit être positif et ne pas dépasser le reste dû.'
                return
            }
            if (!destination || !destination.id || destination.id < 1) {
                this.msg_error = 'Choisissez le compte ou la banque de destination.'
                return
            }
            if (!this.mode_paiement_recu) {
                this.msg_error = 'Choisissez le mode de paiement réellement utilisé.'
                return
            }
            if (this.promesse_apres_acompte) {
                const promiseAmount = Number(this.promesse_montant)
                if (!this.resteApresAcompte || !Number.isSafeInteger(promiseAmount) || promiseAmount <= 0 || promiseAmount > this.resteApresAcompte || !this.promesse_date || !this.promesse_contact.trim() || !this.promesse_action.trim()) {
                    this.msg_error = 'Pour la prochaine promesse, indiquez un montant dans la limite du solde, une date, un contact et l’action prévue.'
                    return
                }
                if (this.promesse_date <= this.date_action) {
                    this.msg_error = 'La prochaine promesse doit être postérieure au versement reçu.'
                    return
                }
            }
            if (!this.is_confirm) {
                this.is_confirm = true
                return
            }
            const confirmation = document.getElementById('cfrm-pay')
            if (!confirmation || !confirmation.checked) {
                this.msg_error = 'Confirmez le montant réellement encaissé.'
                return
            }
            const form = new FormData()
            form.append('request_id', this.payment_request_id)
            form.append('date_action', this.date_action)
            form.append('montant', amount)
            form.append('montant_saisi', montantSaisi)
            form.append('devise_paiement', this.devise_paiement)
            form.append('mode_paiement', this.mode_paiement_recu)
            if (this.devise_paiement === 'USD') form.append('taux_paiement', taux)
            form.append('compte_destination_id', destination.id)
            form.append('timezone', this.getClinicTimezone())
            if (this.commentaire) form.append('commentaire', this.commentaire)
            if (this.file_upload) form.append('preuve', this.file_upload)
            if (this.promesse_apres_acompte) {
                form.append('promesse', 1)
                form.append('promesse_montant', Number(this.promesse_montant))
                form.append('promesse_date', this.promesse_date)
                form.append('promesse_contact', this.promesse_contact.trim())
                form.append('promesse_action', this.promesse_action.trim())
            }
            this.save_loading = true
            try {
                const response = await store_operation.enregistrerPaiementFacture(this.selected_facture.facture_id, form)
                $(this.$refs.paiement_facture).modal('hide')
                this.successToast(response.message)
                this.$emit(this.type_facture == 'facture_assurance' ? 'emitRefreshFacture' : 'emitRefreshFactureForafait')
            } catch (error) {
                this.msg_error = (error.response && error.response.data && (error.response.data.message || Object.values(error.response.data.errors || {})[0])) || 'Impossible d’enregistrer ce versement.'
                if (Array.isArray(this.msg_error)) this.msg_error = this.msg_error[0]
                if (error.response && error.response.status === 422) await this.chargerPaiementsFacture()
            } finally {
                this.save_loading = false
            }
        },

        async enregistrerSuiviRecouvrement() {
            if (this.save_loading) return
            this.msg_error = ''
            if (!this.date_action || !this.personne_contactee.trim()) {
                this.msg_error = 'Renseignez la date et la personne contactée.'
                return
            }
            if (this.mode_suivi === 'relance' && !this.prochaine_relance) {
                this.msg_error = 'Choisissez la date de prochaine relance.'
                return
            }
            if (this.mode_suivi === 'rendez_vous_paiement' && (!this.rendez_vous_at || !this.action_attendue.trim())) {
                this.msg_error = 'Renseignez le rendez-vous et l’action à effectuer.'
                return
            }
            const data = new FormData()
            data.append('facture_id', this.selected_facture.facture_id)
            data.append('type', this.mode_suivi)
            data.append('date_action', this.date_action)
            data.append('personne_contactee', this.personne_contactee.trim())
            data.append('promesse_paiement', this.promesse_paiement.trim())
            data.append('commentaire', this.commentaire.trim())
            data.append('timezone', this.getClinicTimezone())
            if (this.mode_suivi === 'relance') data.append('prochaine_relance', this.prochaine_relance)
            else {
                data.append('rendez_vous_at', this.rendez_vous_at)
                data.append('mode_paiement', this.mode_paiement)
                data.append('action_attendue', this.action_attendue.trim())
            }
            if (this.file_upload instanceof File) data.append('preuve', this.file_upload)
            this.save_loading = true
            try {
                const response = await store_operation.enregistrerSuiviRecouvrement(data)
                if (!response.success) throw new Error(response.message || 'Enregistrement impossible.')
                $('.relance-creance').modal('hide')
                this.successToast(response.message)
                this.$emit(this.type_facture === 'facture_assurance' ? 'emitRefreshFacture' : 'emitRefreshFactureForafait')
            } catch (error) {
                const payload = error.response && error.response.data
                const firstValidation = payload && payload.errors && Object.values(payload.errors)[0]
                this.msg_error = (firstValidation && firstValidation[0]) || (payload && payload.message) || error.message || 'Enregistrement impossible.'
            } finally {
                this.save_loading = false
            }
        },

        fetchSocietInfoByID() {
            store_assurance.getInfoSocieteByID(this.selected_facture.souscripteur_id).then((response) => {
                if (response.success) {
                    this.info_societe = response.data
                }
            })
        },

        setViewPatientBySociete() {
            const tmp_grouped_patients_by_societe = this.selected_facture_detail.groupBy('souscripteur')
            this.view_by_societe = []

            for (const key in tmp_grouped_patients_by_societe) {
                let sum_part_assureur = 0
                tmp_grouped_patients_by_societe[key].forEach(el => {
                    sum_part_assureur += el.part_assureur
                });

                // Group by patient
                const tmp_grouped_patients = tmp_grouped_patients_by_societe[key].groupBy('patient')
                let patients = []
                for (const key_patient in tmp_grouped_patients) {
                    let sum_part_assureur_patient = 0
                    tmp_grouped_patients[key_patient].forEach(el => {
                        sum_part_assureur_patient += el.part_assureur
                    });

                    // get last index date_creance
                    const operations_len = tmp_grouped_patients[key_patient].length
                    const last_operation = tmp_grouped_patients[key_patient][operations_len - 1]
                    const date_creance = last_operation.date_creance

                    const tmp_group_patient = {
                        patient: key_patient,
                        sum_part_assureur: sum_part_assureur_patient,
                        operations: tmp_grouped_patients[key_patient],
                        date_creance: date_creance,
                        num_bon: numerosBon(tmp_grouped_patients[key_patient]),
                        // Matricule, Agent ou lien, n° de bon, âge / sexe (sans répéter le bon, déjà en colonne).
                        mentions: mentionsIdentite(tmp_grouped_patients[key_patient]).filter(m => m.indexOf('N° bon') !== 0)
                    }
                    patients.push(tmp_group_patient)
                }

                const tmp_group = {
                    societe: key,
                    sum_part_assureur: sum_part_assureur,
                    patients: patients
                }
                this.view_by_societe.push(tmp_group)
            }
            
        },

        setViewPatient() {
            const tmp_grouped_patients = this.selected_facture_detail.groupBy('patient')
            this.view_patients = []

            for (const key in tmp_grouped_patients) {
                let sum_part_assureur = 0
                let operations_len = tmp_grouped_patients[key].length
                tmp_grouped_patients[key].forEach(el => {
                    sum_part_assureur += el.part_assureur
                });

                // get last index date_creance
                const last_operation = tmp_grouped_patients[key][operations_len - 1]
                const date_creance = last_operation.date_creance

                const tmp_group = {
                    patient: key,
                    sum_part_assureur: sum_part_assureur,
                    operations: tmp_grouped_patients[key],
                    date_creance: date_creance,
                    num_bon: numerosBon(tmp_grouped_patients[key]),
                    // Ligne du haut : matricule, Agent ou lien, n° de bon, âge / sexe ; détails par rubrique, consultation d'abord.
                    mentions: mentionsIdentite(tmp_grouped_patients[key]),
                    rubriques: grouperParRubrique(tmp_grouped_patients[key])
                }
                this.view_patients.push(tmp_group)
            }
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            this.msg_error = ''
        },

        setVmodel(response) {
            this.file_upload = response.u_file
        },

        arreterFacture(selector) {
            const confirm = document.getElementById(selector);
            if (!confirm.checked) { 
                this.msg_error = "Veuillez confirmer l'arrêt de la facture en cochant la case de confirmation."
                return
            }

            let periode = ''
            if (this.is_month) {
                periode = 'Période du mois de ' + this.current_date_filter.libelle_month
            } else {
                if (this.current_date_filter.one_date != '') {
                    periode = 'Période du ' + this.formatDateToDmY(this.current_date_filter.one_date)
                } else {
                    periode = `Période du ${this.formatDateToDmY(this.current_date_filter.from_date)} au ${this.formatDateToDmY(this.current_date_filter.to_date)}`
                }
            }

            // Go through selected_facture_detail and get only the id into operations
            const operations = this.selected_facture_detail.map(item => ({id: item.id}))

            const data = {
                assurance_id: this.selected_facture.assurance_id,
                assurance: this.selected_facture.assurance,
                societe_id: (this.selected_facture.souscripteur)?this.selected_facture.souscripteur_id:null,
                societe: (this.selected_facture.souscripteur)?this.selected_facture.souscripteur:null,
                data_type: 'remboursement_assurance',
                is_assurance: (this.is_assurance_bill === true)?1:0,
                etat: 1,
                user_id: this.user_info.user_id,
                user: this.user_info.name,
                montant: parseInt(this.selected_facture.sum_part_assureur),
                taux_change: Number(this.currency_info && this.currency_info.rate) > 0 ? Number(this.currency_info.rate) : null,
                periode: periode,
                info_societe: this.info_societe,
                selected_date: {
                    month: this.current_date_filter.month,
                    from_date: this.current_date_filter.from_date,
                    to_date: this.current_date_filter.to_date,
                    one_date: this.current_date_filter.one_date
                },
                operations: operations
            }
            
            this.save_loading = true
            store_operation.arreterFactureAssuranceSociete(data).then((response) => {
                if (response.success) {
                    this.$refs.arret_facture.click()
                    this.successToast(response.message)

                    this.$emit("emitRefreshListeCreanceAssurance")
                    this.$emit('emitGotoFacture')   
                } else {
                    this.msg_err = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.msg_err = "Une erreur est survenue lors de l'enregistrement. Veuillez réessayer plus tard."
            })
        },

        async gererEtatFacture(selector, etat) {
            this.ecart = 0
            if (etat == '4') {
                const isValid = await this.$refs.pay_form.validate();
                if (!isValid) {
                    this.msg_error = 'Merci de remplir tous les champs requis * !'
                    return;
                }

                if (this.selected_facture.sum_part_assureur < this.montant_paye) {
                    this.msg_error = 'Le montant reçu doit être inférieur ou égale au montant dû !'
                    return;
                }

                if (
                    this.selected_facture.sum_part_assureur != this.montant_paye
                ) {
                    this.is_ecart = true
                    const mnt_recu = parseInt(this.montant_paye)
                    this.ecart = this.selected_facture.sum_part_assureur - mnt_recu

                    if (this.commentaire == '') {
                        this.must_justify = true
                        this.is_confirm = false
                        return;
                    }
                }


            }

            if (!this.is_confirm) {
                this.is_confirm = true
                return;
            }

            const confirm = document.getElementById(selector);
            if (!confirm.checked) { 
                if (etat == '2') {
                    this.msg_error = "Veuillez confirmer le dépôt de la facture en cochant la case de confirmation."
                } else if (etat == '3') {
                    this.msg_error = "Veuillez confirmer la relance de la facture en cochant la case de confirmation."
                } else if (etat == '4') {
                    this.msg_error = "Veuillez confirmer le paiement de la facture en cochant la case de confirmation."
                }
                
                return
            }

            let data_type = ''
            let final_selected_compte = null
            if (etat == '2') {
                data_type = 'depot'
            } else if (etat == '3') {
                data_type = 'relance'
            } else if (etat == '4') {
                data_type = 'paiement'
                final_selected_compte = (this.selected_compte.id != -1)?this.selected_compte:this.selected_banque
            }

            const data = {
                facture_id: this.selected_facture.facture_id,
                facture_ref: this.selected_facture.reference,
                data_type: data_type,
                user_id: this.user_info.user_id,
                user: this.user_info.name,
                user_titre: this.user_info.titre,
                date: this.date_action,
                commentaire: this.commentaire,
                montant_du: this.selected_facture.sum_part_assureur,
                montant_paye: (this.montant_paye > 0)?parseInt(this.montant_paye):null,
                selected_compte: final_selected_compte,
                etat: parseInt(etat)
            }
            console.log("data ",data);
            

            let form_data = new FormData();
            for (let key in data) {
                if (typeof(data[key]) != 'object') {
                    form_data.append(key, data[key])
                } else {
                    form_data.append(key, JSON.stringify(data[key]));
                }
            }
            form_data.append('preuve', this.file_upload);

            this.save_loading = true
            store_operation.manageFactureAssuranceSociete(form_data).then((response) => {
                if (response.success) {
                    if (etat == '2') {
                        this.$refs.depot_facture.click()
                    } else if (etat == '3') {
                        this.$refs.relance_facture.click()
                    } else if (etat == '4') {
                        this.$refs.paiement_facture.click()
                    }
                    
                    this.successToast(response.message)
                    if (this.type_facture == 'facture_assurance') {
                        this.$emit("emitRefreshFacture") 
                    } else {
                        this.$emit("emitRefreshFactureForafait") 
                    }
                } else {
                    this.msg_err = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.msg_err = "Une erreur est survenue lors de l'enregistrement. Veuillez réessayer plus tard."
            })
        },

        viewProof(filename) {
            this.can_preview = this.checkIfCanPreview(filename)

            this.filename = this.assets_path + '/files/preuves/'+filename

            this.attach_file_viewer = true
        },

        backToHistorique() {
            this.attach_file_viewer = false
        },

        // « Imprimer » ouvre d'abord le choix de la mise en page, des patients et de la devise.
        ouvrirOptionsImpression() {
            this.format_impression = this.selected_view_type.slug
            this.patients_coches = this.patients_facture.slice()
            if (!this.modes_devise.some(mode => mode.cle === this.devise_impression)) this.devise_impression = 'principale'
            this.options_impression = true
        },

        fermerOptionsImpression() {
            this.options_impression = false
        },

        cocherTousLesPatients(cocher) {
            this.patients_coches = cocher ? this.patients_facture.slice() : []
        },

        setPrintInvoice() {
            if (this.impression_impossible) return
            // Les deux vues sont recalculées : l'impression ne dépend pas de l'onglet affiché à l'écran.
            this.setViewPatientBySociete()
            this.setViewPatient()
            const individuel = this.format_impression === 'individuel'
            const invoice_data = {
                is_assurance_bill: this.is_assurance_bill,
                selected_facture: this.selected_facture,
                view_by_societe: this.view_by_societe,
                view_patients: individuel
                    ? this.view_patients.filter(groupe => this.patients_coches.indexOf(groupe.patient) >= 0)
                    : this.view_patients,
                total_facture: this.total_facture,
                total_en_lettre: this.total_en_lettre,
                selected_view: this.format_impression,
                devise_mode: this.devise_impression,
                periode: this.selected_facture.periode,
                date: this.selected_facture.date
            }
            this.options_impression = false

            this.$emit('emitSetInvoiceToPrint', invoice_data) 
        }
    }
}
